<template>
  <div class="background"></div>
</template>

<script>
export default {};
</script>

<style>
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, #19014e, #2c00a7);
  z-index: -1;
}
</style>
